import {Component, ComponentFactoryResolver, ComponentRef, HostListener, Input, OnDestroy, OnInit, TemplateRef, ViewChild, ViewContainerRef} from '@angular/core';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { Helpers } from 'src/app/model';
import { SearchableItem } from 'src/app/model/interface';
import { PresetValue } from 'src/app/model/preset-value';
import { BVQReportProvider } from 'src/app/providers/bvq';
import { BVQReportService, LockService, ReportSourceService } from '../../services';
import { LogService } from 'src/app/services';

@Component({
  selector: 'bvq-source',
  templateUrl: 'source.html',
  styleUrls: ['source.scss']
})
export class SourceComponent implements OnInit, OnDestroy {
  @Input() fieldSource: string;
  @Input() fieldNote: string;
  @Input() fieldName: string;
  @Input() fieldSourceTitle: string;
  @Input() top: string;
  @Input() right: string;
  @Input() disabled: boolean = false;

  headerName: string;
  modalRef: BsModalRef;
  sourceName: string;
  sourceSub: any;
  tempFieldSource: string = '';
  tempFieldNote: string = '';
  tempFieldSourceTitle: string = '';
  visible: boolean;

  sourceValues: SearchableItem[] = [];

  constructor(
    public sourceService: ReportSourceService,
    public lockService: LockService,
    private reportService: BVQReportService,
    private reportProvider: BVQReportProvider,
    private modalService: BsModalService,
    private logService : LogService
  ) {

    for (let source of sourceService.getSources()){
      if(source.SOURCE_CODE != null)
        this.sourceValues.push(PresetValue.create(source.SOURCE_NAME, source.SOURCE_CODE))
    }
  }

  ngOnInit(): void {
    this.getHeaderName();
  }

  ngOnDestroy(): void {
    if(this.sourceSub) this.sourceSub.unsubscribe();
  }

  acceptChanges(): void {
    if(this.tempFieldSource != null && this.tempFieldSource != 'null'){
      this.fieldSource = JSON.parse(JSON.stringify(this.tempFieldSource));
      this.fieldNote = JSON.parse(JSON.stringify(this.tempFieldNote));
      this.fieldSourceTitle = JSON.parse(JSON.stringify(this.tempFieldSourceTitle));


      this.reportProvider.saveReportFieldSource(this.reportService.getReport(), this.fieldName, this.fieldSource, this.fieldNote, this.fieldSourceTitle)
        .subscribe(
          data => {
            if (data.success) {
              this.reportService.fieldSourceChanged(this.fieldName, this.fieldSource, this.fieldNote, this.fieldSourceTitle);
              this.sourceName = this.sourceService.getSource(this.fieldSource);
              this.modalRef.hide();
            } else {
              this.logService.log('Error Saving Source for Field!');
            }
          }, err => {
            this.logService.log('Error Saving Source for Field [' + err + ']');
          });
    }
  }

  getHeaderName(): void {
    if (this.fieldName.toString().includes(':')) {
      let index = this.fieldName.indexOf(':');
      this.headerName = this.fieldName.substr(0, index);
    }
    else
      this.headerName = this.fieldName;
  }

  openModal(template: TemplateRef<any>): void {
    this.tempFieldSource = JSON.parse(JSON.stringify(this.fieldSource));
    this.tempFieldNote = JSON.parse(JSON.stringify(this.fieldNote));
    this.tempFieldSourceTitle = this.fieldSourceTitle ? JSON.parse(JSON.stringify(this.fieldSourceTitle)) : "";
    this.modalRef = this.modalService.show(template, Helpers.getModalConfig());
  }

  sourceValueChanged(value: any): void {
    this.tempFieldSource = value != null ? value.VALUE: null;

    if(this.tempFieldSource == null)
      this.tempFieldSourceTitle = '';
  }


  showInfo(): void {
    if (this.visible || this.disabled) {
      return;
    }

    this.visible = true;
  }

  @HostListener('mouseleave')
  hideInfo(): void {
    if (!this.visible) {
      return;
    }

    this.visible = false;
  }
}
